import { __decorate } from "tslib";
import { provide } from '@/inversify.config';
export const ReportTemplateData = Symbol('ReportTemplateData');
let ReportTemplateDataImpl = class ReportTemplateDataImpl {
    setData(data) {
        this._data = data;
    }
    getData() {
        if (!this._data) {
            throw new Error('未找到复制报告为模板的数据');
        }
        return this._data;
    }
};
ReportTemplateDataImpl = __decorate([
    provide(ReportTemplateData)
], ReportTemplateDataImpl);
export { ReportTemplateDataImpl };
